import React, {useEffect, useState, Fragment} from 'react'
import PropTypes from 'prop-types'
import {makeStyles} from '@mui/styles'
import {KYRLoaderScreen} from '../../assets/styles/layout'
import moment from 'moment'
import Loader from '../Loader'
import KYRDataField from './KYRDataField'
import {getIncomingDelivery} from '../../lib/queries'
import {capitalizeFirstLetter} from '../../Utils/StringFormatter'
import TimelineEvent from './TimelineEvent'

const useStyles = makeStyles(theme => ({
  loader: {
    ...KYRLoaderScreen,
  },
}))

function IncomingDelivery(props) {
  const classes = useStyles()
  const [deliveryInfo, setDeliveryInfo] = useState({})
  const [isDeliveryInfoLoading, setDeliveryInfoLoading] = useState(true)

  useEffect(() => {
    getIncomingDelivery(props.deliveryId)
      .then(res => {
        setDeliveryInfo(res)
        setDeliveryInfoLoading(false)
      })
      .catch(err => console.error(err))
  }, [])

  const mapPriorityOptions = {
    HIGH: 'High',
    LOW: 'Normal',
  }

  const receivedAt = deliveryInfo.receivedAt ? `${moment(deliveryInfo.receivedAt).format('MMM Do YYYY, h:mm a')}` : ''
  const status = !deliveryInfo.deliveredDetails
    ? 'Arrived at front desk '
    : deliveryInfo.deliveredDetails.deliveredTo === 'unit'
    ? 'Delivered'
    : `Picked up by ${deliveryInfo.deliveredDetails.recipientName}`

  return (
    <Fragment>
      {isDeliveryInfoLoading ? (
        <Loader className={classes.loader} />
      ) : (
        <div>
          <KYRDataField title="Incoming or outgoing" data="Incoming" />
          <KYRDataField title="Status" data={status} />
          <KYRDataField title="Package type" data={deliveryInfo.packageType && capitalizeFirstLetter(deliveryInfo.packageType)} />
          <KYRDataField title="Tracking number" data={deliveryInfo.trackingNumber} />
          <KYRDataField title="Carrier" data={deliveryInfo.carrier && capitalizeFirstLetter(deliveryInfo.carrier)} />
          <KYRDataField title="Priority level" data={mapPriorityOptions[deliveryInfo.priority]} />
          <KYRDataField title="Arrived on" data={receivedAt} />
          <KYRDataField title="Notes" data={deliveryInfo.notes} />
          <TimelineEvent primaryRecordId={props.deliveryId} />
        </div>
      )}
    </Fragment>
  )
}

IncomingDelivery.propTypes = {
  deliveryId: PropTypes.string.isRequired,
}

export default IncomingDelivery
